import { TbBoxMultiple, TbChevronDown } from "solid-icons/tb";
import { type Component, createSignal } from "solid-js";
import { ProjectSwitcherModal } from "~/components/projects/ProjectSwitcherModal";
import { useGateActionByAuthenticated } from "~/hooks/useGateActionByAuthenticated";
import { useWire } from "~/wire";

export const ProjectSwitcher: Component = () => {
  const [isCreateModalOpen, setIsCreateModalOpen] = createSignal(false);

  const wire = useWire();
  const active = () => {
    const userContext = wire.userContext.get();
    if (!userContext) return undefined;
    return wire.projects.get(userContext.projectId);
  };

  const openCreateModal = useGateActionByAuthenticated(
    () => ({
      title: "Sign up to create and share Projects",
      description: "Projects are a great way to collaborate with colleagues, teams and communities.",
    }),
    () => setIsCreateModalOpen(true),
  );

  return (
    <>
      <button
        type="button"
        onClick={openCreateModal}
        class="w-full text-left bg-panel hover:bg-panel-hover cursor-pointer border border-primary-border rounded-lg pt-2 pb-2 px-3 "
      >
        <p class="text-xs opacity-50 mb-1">In Project:</p>
        <div class="flex items-center gap-2">
          <TbBoxMultiple />
          <span class="flex-auto">{active()?.name}</span>
          <TbChevronDown class="w-4 h-4 text-muted-text" />
        </div>
      </button>
      <ProjectSwitcherModal open={isCreateModalOpen()} onOpenChange={setIsCreateModalOpen} />
    </>
  );
};
